<!-- Pastille compte : ☰ + avatar (connecté) ou ☰ + silhouette (visiteur). Le menu regroupe la navigation
     (quand l'en-tête est trop étroit pour l'afficher), le compte, le thème et la langue. -->
<button
  #accountBtn
  class="acct"
  type="button"
  [cdkMenuTriggerFor]="accountMenu"
  [cdkMenuPosition]="positions"
  aria-haspopup="true"
  [attr.aria-label]="'AVATAR_MENU.MENU' | translate"
  [title]="authService.currentUser()?.displayName ?? ('AVATAR_MENU.MENU' | translate)"
  data-testid="account-menu-btn"
>
  <i class="ls-ic ls-menu" aria-hidden="true"></i>
  @if (authService.isAuthenticated()) {
    <ls-user-avatar [user]="authService.currentUser() ?? undefined" [size]="28" />
  } @else {
    <span class="acct-guest" aria-hidden="true"><i class="ls-ic ls-user"></i></span>
  }
</button>

<ng-template #accountMenu>
  <div class="ghead-pop ghead-avatar-pop" cdkMenu data-testid="account-menu">
    @if (authService.isAuthenticated()) {
      <div class="ghead-who">
        <ls-user-avatar [user]="authService.currentUser() ?? undefined" [size]="30" />
        <div>
          <p class="ghead-who-name">{{ authService.currentUser()?.displayName }}</p>
          <p class="ghead-who-email">{{ authService.currentUser()?.email }}</p>
        </div>
      </div>
      <hr class="ghead-sep" />
    }

    <!-- Navigation : seulement quand les liens de l'en-tête sont masqués (≤ 1024 px) -->
    @if (navItems().length > 0) {
      <div class="menu-nav" cdkMenuGroup>
        @for (item of navItems(); track item.commands.join('/')) {
          <a cdkMenuItem [routerLink]="['/', lang(), ...item.commands]">
            {{ item.key ? (item.key | translate) : item.label }}
          </a>
        }
        <hr class="ghead-sep" />
      </div>
    }

    @if (authService.isAuthenticated()) {
      <a cdkMenuItem [routerLink]="adminRoute(routeName.MyLibrary)">
        <i class="ls-book" aria-hidden="true"></i> {{ 'AVATAR_MENU.LIBRARY' | translate }}
      </a>
      <a cdkMenuItem [routerLink]="adminRoute(routeName.MySettings)">
        <i class="ls-settings" aria-hidden="true"></i> {{ 'AVATAR_MENU.SETTINGS' | translate }}
      </a>
      @if (showFullWidthBtn()) {
        <button
          type="button"
          cdkMenuItem
          role="menuitemcheckbox"
          [attr.aria-checked]="isFullscreen()"
          (cdkMenuItemTriggered)="onToggleFullscreen()"
        >
          <i class="ls-layout-panel-left" aria-hidden="true"></i>
          {{ (isFullscreen() ? 'AVATAR_MENU.CENTERED' : 'AVATAR_MENU.FULL_WIDTH') | translate }}
          @if (isFullscreen()) { <span class="ghead-check" aria-hidden="true">✓</span> }
        </button>
      }
    } @else {
      <button type="button" cdkMenuItem (cdkMenuItemTriggered)="loginRequested.emit()" data-testid="account-menu-login">
        <i class="ls-log-in" aria-hidden="true"></i> {{ 'HEADER.LOGIN' | translate }}
      </button>
      <a cdkMenuItem class="ghead-strong" [routerLink]="['/', lang(), routeName.GetStarted]">
        <i class="ls-user-plus" aria-hidden="true"></i> {{ 'HEADER.GET_STARTED' | translate }}
      </a>
    }

    <hr class="ghead-sep" />

    <!-- Thème : trois pastilles (clair / sombre / auto), le menu reste ouvert pour voir le changement -->
    <div class="theme-row">
      <span>{{ 'AVATAR_MENU.THEME' | translate }}</span>
      <div class="theme-seg" role="radiogroup" [attr.aria-label]="'AVATAR_MENU.THEME' | translate">
        @for (opt of themeModes; track opt.mode) {
          <button
            type="button"
            role="radio"
            [class.on]="themeService.currentMode() === opt.mode"
            [attr.aria-checked]="themeService.currentMode() === opt.mode"
            [attr.aria-label]="opt.labelKey | translate"
            [title]="opt.labelKey | translate"
            (click)="themeService.setTheme(opt.mode)"
            [attr.data-testid]="'theme-' + opt.mode"
          >
            <i class="ls-ic {{ opt.icon }}" aria-hidden="true"></i>
          </button>
        }
      </div>
    </div>

    <!-- Langue : drapeau + nom de la langue courante, sous-menu avec les quatre langues -->
    <button
      type="button"
      cdkMenuItem
      class="lang-row"
      [cdkMenuTriggerFor]="langMenu"
      [cdkMenuPosition]="subPositions"
      data-testid="account-menu-lang"
    >
      <i class="ls-globe" aria-hidden="true"></i>
      <span class="lang-cur">
        <span class="flag" aria-hidden="true">{{ langService.currentLang().flag }}</span>
        {{ langService.currentLang().label }}
      </span>
      <i class="ls-chevron-right lang-chev" aria-hidden="true"></i>
    </button>

    @if (authService.isAuthenticated()) {
      <hr class="ghead-sep" />
      <button type="button" cdkMenuItem class="ghead-danger" (cdkMenuItemTriggered)="logout()">
        <i class="ls-log-out" aria-hidden="true"></i> {{ 'AVATAR_MENU.LOGOUT' | translate }}
      </button>
    }
  </div>
</ng-template>

<ng-template #langMenu>
  <div class="ghead-pop ghead-lang-pop" cdkMenu [attr.aria-label]="'LANG_PICKER.MENU_LABEL' | translate" data-testid="account-lang-menu">
    <div cdkMenuGroup>
      @for (option of langOptions; track option.value) {
        <button
          type="button"
          cdkMenuItemRadio
          [class.on]="langService.currentLang().value === option.value"
          [cdkMenuItemChecked]="langService.currentLang().value === option.value"
          (cdkMenuItemTriggered)="langService.switchLang(option.value)"
          [attr.data-testid]="'account-lang-' + option.value"
        >
          <span class="flag" aria-hidden="true">{{ option.flag }}</span>
          {{ option.label }}
          @if (langService.currentLang().value === option.value) { <span class="ghead-check" aria-hidden="true">✓</span> }
        </button>
      }
    </div>
  </div>
</ng-template>
